<template>
  <nav class="navbar navbar-expand navbar-light topbar static-top align-items-stretch p-0 d-print-none">
    <div class="d-flex home align-items-center">
      <router-link :to="{name: 'dashboard'}" class="navbar-logo-link">
        <span class="navbar-brand-mark">
          <img :src="logoSrc" alt="MANET Marketing Logo" class="navbar-logo">
        </span>
        <span class="navbar-brand-copy d-none d-lg-flex">
          <span class="navbar-brand-eyebrow">Customer Control Panel</span>
          <span class="navbar-brand-title">MANET Cockpit</span>
        </span>
      </router-link>
    </div>
    <div class="d-flex toggle-sidebar align-items-center">
      <button type="button" class="toggle mx-3 hover-pointer" @click="$emit('toggleSidebar')" aria-label="Navigation umschalten">
        <Icon icon="fa-pro-solid:bars" />
      </button>
    </div>
    <Messages />
    <ul class="navbar-nav ms-auto align-items-center">
      <li class="nav-item d-none d-xl-flex">
        <div class="navbar-session-pill">
          <span class="navbar-session-pill__dot"></span>
          Sitzung bis {{ logoutTime }}
        </div>
      </li>
      <li class="nav-item dropdown no-arrow">
        <a class="nav-link dropdown-toggle navbar-user-link" href="#" id="userDropdown" role="button" data-bs-toggle="dropdown"
           aria-haspopup="true" aria-expanded="false">
          <span class="navbar-user-copy d-none d-lg-flex">
            <span class="navbar-user-meta">Angemeldet als</span>
            <span class="navbar-user-name">
              {{ displayName }}
              <span v-if="user.organisation.kdnr" class="navbar-user-org">
                {{ user.organisation.name }} ({{ user.organisation.kdnr }})
              </span>
            </span>
          </span>
          <span class="navbar-user-avatar">
            {{ userInitials }}
          </span>
          <Icon
            v-if="userNeedsAttention"
            icon="fa-pro-solid:triangle-exclamation"
            class="navbar-user-alert"
            title="Es gibt offene Punkte in Ihrem Konto."
          />
        </a>
        <div class="dropdown-menu shadow dropdown-menu-end animated--grow-in navbar-user-menu" aria-labelledby="userDropdown">
          <div class="navbar-user-menu__summary">
            <div class="navbar-user-menu__avatar">{{ userInitials }}</div>
            <div>
              <div class="navbar-user-menu__name">{{ displayName }}</div>
              <div class="navbar-user-menu__email">{{ user.email }}</div>
            </div>
          </div>
          <template v-if="user.getOrganisations().length">
            <template :key="index" v-for="(org, index) in user.getOrganisations()">
              <a :href="getOrganisationHref(org)"
                 @click.prevent="selectOrganisation(org)"
                 class="dropdown-item navbar-user-menu__org" :class="{ active: user.organisation.kdnr === org.kdnr }">
                {{ org.name }} ({{ org.kdnr }})
              </a>
            </template>
            <div class="dropdown-divider"></div>
          </template>
          <template v-if="userStore.isImpersonating">
            <button
              type="button"
              class="dropdown-item navbar-user-menu__stop-impersonation"
              :disabled="userStore.stoppingImpersonation"
              @click="stopImpersonating"
            >
              <Icon icon="fa-pro-solid:user-check" class="ify-sm mr-2" />
              {{ userStore.stoppingImpersonation ? 'Restoring session...' : 'Stop impersonating' }}
            </button>
            <div class="navbar-user-menu__impersonation-note">
              Back to {{ originalStaffName }}
            </div>
            <div class="dropdown-divider"></div>
          </template>
          <router-link :to="{ name: 'account.settings'}" class="dropdown-item">
            <Icon icon="fa-pro-solid:gears" class="navbar-user-menu__icon ify-sm mr-2 text-gray-400" />
            Einstellungen
            <Icon
              v-if="showAttentionWarning('account.settings')"
              icon="fa-pro-solid:triangle-exclamation"
              class="ms-2 text-warning"
              title="Bitte hinterlegen Sie Ihre Adresse."
            />
          </router-link>
          <!--          <div class="dropdown-divider"></div>-->
          <a class="dropdown-item" href="javascript:void(0);" @click="logout">
            <Icon icon="fa-pro-solid:right-from-bracket" class="navbar-user-menu__icon ify-sm mr-2 text-gray-400" />
            abmelden
          </a>
        </div>
      </li>

    </ul>
  </nav>
</template>

<script>
import {useUserStore} from "@/stores/user";
import Messages from "@/components/general/Messages.vue"
export default {
  components: {
    Messages
  },
  setup() {
    const userStore = useUserStore()
    return {userStore}
  },
  data() {
    return {
      name: null,
    }
  },
  props: {
    isMobile: Boolean
  },
  created() {

  },
  computed: {
    logoSrc() {
      return this.isMobile
          ? require("@/assets/img/manet-mobile-logo.png")
          : require("@/assets/img/manet-single-logo.png")
    },
    user() {
      return this.userStore.user
    },
    userNeedsAttention() {
      return this.user.needsAttention()
    },
    displayName() {
      return `${this.user.first_name || ''} ${this.user.last_name || ''}`.trim() || this.user.email || 'Konto'
    },
    userInitials() {
      const source = this.displayName
      return source
          .split(' ')
          .filter(Boolean)
          .slice(0, 2)
          .map((part) => part.charAt(0).toUpperCase())
          .join('') || 'M'
    },
    logoutTime() {
      if (!this.user?.exp) {
        return '--:--'
      }

      return new Date(Number(this.user.exp) * 1000).toLocaleTimeString('de-DE', {
        hour: '2-digit',
        minute: '2-digit',
      })
    },
    originalStaffName() {
      return this.formatPerson(this.userStore.impersonation?.impersonator) || 'MANET'
    }
  },
  methods: {
    formatPerson(person) {
      if (!person) {
        return ''
      }

      return `${person.first_name || ''} ${person.last_name || ''}`.trim() || person.email || ''
    },
    logout(e) {
      e.preventDefault()
      this.userStore.logout()
    },
    stopImpersonating() {
      this.userStore.stopImpersonating()
    },
    getOrganisationLocation(org) {
      return {
        path: this.$route.path || '/',
        query: {
          ...this.$route.query,
          kdnr: org.kdnr,
        },
        hash: this.$route.hash,
      }
    },
    getOrganisationHref(org) {
      return this.$router.resolve(this.getOrganisationLocation(org)).href
    },
    selectOrganisation(org) {
      this.user.setOrganisation(org)
      this.$router.push(this.getOrganisationLocation(org)).catch(() => {})
    },
    showAttentionWarning(route) {
      return this.user.needsAttention(route)
    },
    navigate(item) {
      this.userStore.activeMenu = item.name
    }
  },
}
</script>

<style scoped lang="scss">
.navbar-logo-link {
  display: inline-flex;
  align-items: center;
  gap: 0.95rem;
  padding: 0 1.25rem;
  min-height: 100%;
  max-width: 100%;
  text-decoration: none;
}

.navbar-brand-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.8rem;
  height: 2.8rem;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0.03));
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.18);
}

.navbar-brand-copy {
  flex-direction: column;
  gap: 0.12rem;
}

.navbar-brand-eyebrow {
  font-size: 0.67rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(230, 244, 255, 0.72);
}

.navbar-brand-title {
  font-size: 1rem;
  font-weight: 700;
  color: #fff;
}

.navbar-logo {
  height: 1.55rem;
  width: auto;
  max-width: 100%;
  object-fit: contain;
  filter: brightness(0) invert(1);
}

.toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem;
  height: 2.75rem;
  border: 0;
  background: rgba(11, 41, 66, 0.06);
  color: #123754;
  transition: transform 0.18s ease, background-color 0.18s ease, color 0.18s ease;
}

.toggle:hover,
.toggle:focus-visible {
  background: rgba(27, 108, 151, 0.12);
  color: #0a5477;
  transform: translateY(-1px);
}

.navbar-session-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.7rem 0.95rem;
  margin-right: 0.9rem;
  border: 1px solid rgba(17, 57, 85, 0.08);
  background: rgba(255, 255, 255, 0.82);
  color: #315068;
  font-size: 0.88rem;
  font-weight: 600;
}

.navbar-session-pill__dot {
  width: 0.55rem;
  height: 0.55rem;
  background: linear-gradient(135deg, #30b9ec, #1b6c97);
  box-shadow: 0 0 0 0.3rem rgba(48, 185, 236, 0.12);
}

.navbar-user-link {
  display: inline-flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.55rem 0.75rem !important;
  border: 1px solid rgba(17, 57, 85, 0.08);
  background: rgba(255, 255, 255, 0.88);
  color: #183752 !important;
}

.navbar-user-copy {
  flex-direction: column;
  align-items: flex-end;
  line-height: 1.1;
}

.navbar-user-meta {
  font-size: 0.68rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #6f8799;
}

.navbar-user-name {
  font-size: 0.95rem;
  font-weight: 700;
  color: #16324a;
}

.navbar-user-org {
  display: block;
  margin-top: 0.2rem;
  font-size: 0.78rem;
  font-weight: 500;
  color: #5f7283;
}

.navbar-user-avatar,
.navbar-user-menu__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.6rem;
  height: 2.6rem;
  background: linear-gradient(135deg, #0d4f71, #1b6c97 58%, #30b9ec);
  color: #fff;
  font-weight: 700;
}

.navbar-user-alert {
  color: #f0a62f;
}

.navbar-user-menu {
  min-width: 19rem;
  border: 1px solid rgba(10, 57, 85, 0.08);
  padding: 0.55rem;
}

.navbar-user-menu__summary {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  padding: 0.55rem 0.65rem 0.85rem;
}

.navbar-user-menu__name {
  font-weight: 700;
  color: #16324a;
}

.navbar-user-menu__email {
  color: #6f8799;
  font-size: 0.88rem;
}

.navbar-user-menu__icon {
  flex: 0 0 1.25em;
  width: 1.25em;
}

.navbar-user-menu__stop-impersonation {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  margin: 0.15rem 0;
  border: 1px solid rgba(202, 45, 45, 0.22);
  background: rgba(202, 45, 45, 0.08);
  color: #8f2525;
  font-weight: 800;
}

.navbar-user-menu__stop-impersonation:disabled {
  opacity: 0.72;
}

.navbar-user-menu__impersonation-note {
  padding: 0.15rem 0.75rem 0.35rem;
  color: #7b5860;
  font-size: 0.78rem;
}

@media (max-width: 991.98px) {
  .navbar-logo-link {
    padding: 0 0.8rem;
    gap: 0.5rem;
  }

  .navbar-brand-mark {
    width: 2.3rem;
    height: 2.3rem;
  }

  .toggle {
    width: 2.4rem;
    height: 2.4rem;
  }
}
</style>
